import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import ErrorBlock from "../common/Errors/errorBlock";
import useAuthorization from "../../hooks/useAuthorization";

// v6 guard: renders its children when authorized, else redirects to /login.
export const PrivateRoute = ({ children }) => {
  const { validateToken } = useAuthorization();
  const isValid = validateToken(localStorage.getItem("token"));

  return isValid ? (
    <ErrorBlock>{children}</ErrorBlock>
  ) : (
    <Navigate to="/login" replace />
  );
};

PrivateRoute.propTypes = {
  children: PropTypes.node,
};
